import PropTypes from 'prop-types'
import Pill from '../FlowDiagram/Pill'

// Renders all theme, social criteria, and impact nodes with hover support
const ThemeNodes = ({ nodes, hoveredNodeId, onNodeHover, onNodeLeave, onNodeMove, isExporting = false }) => {
  return (
    <g>
      {nodes.map(node => (
        <Pill
          key={node.id}
          x={node.x}
          y={node.y}
          w={node.w}
          h={node.h}
          fill={node.fill}
          text={node.label}
          secondaryText={node.secondaryLabel}
          isHovered={hoveredNodeId === node.id}
          onMouseEnter={event => onNodeHover(node, event)}
          onMouseLeave={onNodeLeave}
          onMouseMove={onNodeMove}
          isExporting={isExporting}
        />
      ))}
    </g>
  )
}

ThemeNodes.propTypes = {
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      w: PropTypes.number.isRequired,
      h: PropTypes.number.isRequired,
      fill: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      secondaryLabel: PropTypes.string
    })
  ).isRequired,
  hoveredNodeId: PropTypes.string,
  onNodeHover: PropTypes.func.isRequired,
  onNodeLeave: PropTypes.func.isRequired,
  onNodeMove: PropTypes.func.isRequired,
  isExporting: PropTypes.bool
}

export default ThemeNodes
